module.exports = __webpack_public_path__ + "img/stripe_credit-cards.af7d56ff.jpg";